import { makeObservable } from 'mobx';

import { MaxPaymentAmountData, MaxPaymentAmountListQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export class MaxPaymentAmountList extends LongList<
    MaxPaymentAmountData,
    MaxPaymentAmountData,
    MaxPaymentAmountListQuery
> {
    public static Name = 'maxPaymentAmountList' as const;
    public readonly limit = 50;

    constructor(params?: MaxPaymentAmountData[]) {
        super(params);
        makeObservable(this);
    }

    protected create(params: MaxPaymentAmountData): MaxPaymentAmountData {
        return params;
    }
}

export const maxPaymentAmountList = new MaxPaymentAmountList();
